'use client';

import Image, { StaticImageData } from 'next/image';
import { useRef } from 'react';
import SwipeContainer from './SwipeContainer';

interface WelcomeSlide {
  title: string;
  subtitle: string;
  img: StaticImageData;
}

interface WelcomeCarouselProps {
  slides: WelcomeSlide[];
  onSlideChange?: (index: number) => void;
  bottomSpacing?: string;
}

const WelcomeCarousel = ({
  slides,
  onSlideChange,
  bottomSpacing = 'mb-2',
}: WelcomeCarouselProps) => {
  const containerRef = useRef<HTMLDivElement>(null);

  return (
    <SwipeContainer
      ref={containerRef}
      onIndexChange={onSlideChange}
      showPagination={slides.length > 1}
      paginationStyle="custom"
    >
      {slides.map((slide, index) => (
        <div
          key={index}
          className="flex-none w-full h-full px-4 flex flex-col justify-end"
        >
          <div
            className={`relative w-full mb-6 ${index === 0 ? 'aspect-square max-w-[120px] mx-auto' : 'aspect-[16/9]'}`}
          >
            <Image
              src={slide.img}
              alt={slide.title}
              priority
              className="w-full h-full object-contain rounded-lg pointer-events-none select-none"
              fill
              draggable={false}
            />
          </div>
          <div className="text-center max-w-sm mx-auto w-full">
            <h1 className="text-[28px] sm:text-3xl font-semibold mb-3 text-[#4A16B8] leading-tight tracking-tighter">
              {slide.title}
            </h1>
            <p
              className={`text-sm sm:text-base font-normal ${bottomSpacing} text-gray-500 leading-tight tracking-tighter text-center max-w-2xs mx-auto`}
            >
              {slide.subtitle}
            </p>
          </div>
        </div>
      ))}
    </SwipeContainer>
  );
};

export default WelcomeCarousel;
